import React from "react";
import {cx} from "../lib/ClassSet";
import "./Checkbox.scss";

const Checkbox = (props) => {

  let classes = cx({
    "Checkbox": true,
    "s-active": props.active,
    "s-inactive": !props.active,
    "s-checked": props.checked,
    "s-unchecked": !props.checked,
    "u-no-margin": props.noMargin,
  })

  function handleClick(e) {
    e.stopPropagation();
    if (props.active) {
      props.onClick(e);
    }
  }

  return (
    <div className={classes} onClick={handleClick}>
      <div className="box">
        <div className="icon" />
      </div>
      <div className="label">{props.label}</div>
    </div>
  )
}

Checkbox.defaultProps = {
  active: true,
  checked: false,
  noMargin: false
}

export default Checkbox;